import React from 'react';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import StaticPage from '../StaticPage/StaticPage';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import JotformEmbed from 'react-jotform-embed';

import css from './EncorePage.module.css';

const EncorePage = () => {
  return (
    <StaticPage
      title="Encore Envelope"
      description="Cleaning out your dance drawer has never been easier. Simply fill out the form below to receive your encore envelope and to take the easy steps to declutter your life, upcycle your dancewear, and earn some extra cash."
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: 'Order Encore Envelope',
        name: 'Encore Envelope',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.jotform}>
            <JotformEmbed src="https://form.jotformeu.com/222228090586053" />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default EncorePage;
